import { render } from "./Main.vue?vue&type=template&id=59feb3d9"
const script = {}
script.render = render

export default script